import { GET_GOVBR_MENU } from '../../constants/ActionTypes';

export function getGovBRMenu() {
  return {
    type: GET_GOVBR_MENU,
    request: {
      op: 'get',
      path: '/@govbr-menu',
    },
  };
}
